var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoNike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 23,
    viewBox: "0 0 64 23",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.198 1.02C4.033 5.904.04 11.96 0 16.486c-.015 1.704.53 3.19 1.835 4.317 1.88 1.622 3.951 2.194 6.012 2.197 3.012.004 6.003-1.21 8.345-2.145C20.136 19.28 63.73.377 63.73.377c.42-.21.342-.473-.184-.342-.213.053-47.46 12.838-47.46 12.838-.895.253-1.82.385-2.75.393-3.63.022-6.862-1.99-6.836-6.232.01-1.66.52-3.66 1.698-6.014Z",
    fill: "#94a3b8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNike);
export default __webpack_public_path__ + "static/media/logo-nike.4844a0f22398926ab4082fe3b8fbe7fd.svg";
export { ForwardRef as ReactComponent };